import { render, staticRenderFns } from "./DialogEditDirectory.vue?vue&type=template&id=37aabb0c&scoped=true"
import script from "./DialogEditDirectory.vue?vue&type=script&lang=js"
export * from "./DialogEditDirectory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37aabb0c",
  null
  
)

export default component.exports